
















import Vue, { AsyncComponent } from 'vue';

import TasksManager from './components/TasksManager.vue';

export default Vue.extend({
    components: {
        TasksManager,
    },
    methods: {
        createWorkspace() {
            this.$ui.openDialog(() => import('@/dialogs/WorkspaceForm.vue'));
        },
    },
});
